import React, { Component } from "react";
import Typography from '@mui/material/Typography';
import GPAP_Button from "../../../gpap-lib/Button_Collection";
import Grid from '@mui/material/Grid';

import SearchIcon from '@mui/icons-material/Search';

class Management extends Component {
  render() {
    return (
        <div className="home">
           {/* <h2 id="home_header">Browse and manage your Data</h2>*/}
            <Typography variant={"h4"} align={"center"}> Browse and manage your Data </Typography>
            <hr className = "divider"/>
            <div className="ctas">
                <div className="container">
                    <Grid container direction={"column"} justifyContent={"center"} spacing={2}>
                        <Grid item xs={12}><GPAP_Button
                            style={{width: "300px"}}
                            href = "#/experiments"  startIcon={<SearchIcon />}>
                            EXPERIMENTS
                        </GPAP_Button></Grid>
                        <Grid item xs={12}> <GPAP_Button
                            style={{width: "300px"}}
                            href = "#/files"  startIcon={<SearchIcon />}>
                            FILES
                        </GPAP_Button></Grid>
                        <Grid item xs={12}><GPAP_Button
                            style={{width: "300px"}}
                            href = "#/staticdataaccess"  startIcon={<SearchIcon />}>
                            STATISTICS ON EXPERIMENT ACCESS
                        </GPAP_Button></Grid>
                        <Grid item xs={12}><GPAP_Button
                            style={{width: "300px"}}
                            href = "#/experimentanalysisstatus"  startIcon={<SearchIcon />}>
                            EXPERIMENT ANALYSIS STATUS
                        </GPAP_Button></Grid>
                        <Grid item xs={12}><GPAP_Button
                            style={{width: "300px"}}
                            href = "#/qcmetrics"  startIcon={<SearchIcon />}>
                            EXPERIMENT QC METRICS
                        </GPAP_Button></Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
  }
}

export default Management;
